import { createSelector } from '@ngrx/store';
import { IRevenueState } from './revenue.reducer';
const revenueStore = (state: any) => state.revenue as IRevenueState;
export const selectRevenueLista = createSelector(
  revenueStore,
  (state) => state.lista
);

export const selectRevenueLoading = createSelector(
  revenueStore,
  (state) => state.isLoading
);
